import React, { useState, useEffect, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getWastePoolList } from "../services/dutyService";
import { Toast } from "primereact/toast";
import "primereact/resources/themes/lara-light-blue/theme.css";  // Tema
import "primereact/resources/primereact.min.css";               // Bileşen stilleri
import "primeicons/primeicons.css";                             // İkonlar
import { Dialog } from "primereact/dialog";
import { Dropdown } from 'primereact/dropdown';
import "../styles/pages/_route-plans.scss";// genellikle index.js veya App.js üstüne
import 'primereact/resources/themes/lara-light-blue/theme.css';  // veya başka bir tema
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
// 📅 Tarih formatlayıcı
const formatDate = (dateStr) => {
  if (!dateStr) return "";
  const date = new Date(dateStr);
  return date.toLocaleDateString("tr-TR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};

const WastePool = ({ onFilterChange, currentFilters = {} }) => {
  const [selectedFilters, setSelectedFilters] = useState({
    ...currentFilters,
    datetime: "",
  });
  const [selectedImage, setSelectedImage] = useState(null);
  const [showImageDialog, setShowImageDialog] = useState(false);

  // Yeni state: Grup seçenekleri
  const [tableData, setTableData] = useState([]);

  const [dateRange, setDateRange] = useState({
    basla: new Date().toISOString().split("T")[0]
  });

  const toast = useRef(null);

  const fetchTaskLists = async (filters) => {
    try {
      const response = await getWastePoolList(filters);
      const data = response.data;
      if (Array.isArray(data.data)) {
        setTableData(data.data);
      } else {
        console.warn("TaskLists verisi beklenen formatta değil:", data);
      }
    } catch (error) {
      console.error("TaskLists verisi çekilirken hata:", error);
    }
  };
  <Dialog
  visible={showImageDialog}
  onHide={() => setShowImageDialog(false)}
  header="Fotoğraf Önizleme"
  style={{ width: "60vw" }}
>
 
  {selectedImage && (
    <img
      src={selectedImage}
      alt="Büyük Fotoğraf"
      style={{ width: "100%", height: "auto" }}
    />
  )}
</Dialog>

  useEffect(() => {
    fetchTaskLists(dateRange);

  }, []);

  const imageBodyTemplate = (rowData) => {
    if (!rowData.foto) return null;
    return (
      <img
        src={rowData.foto}
        alt="Fotoğraf"
        style={{
          maxWidth: "100px",
          maxHeight: "100px",
          cursor: "pointer",
          objectFit: "cover",
        }}
        onClick={() => {
          console.log("Tıklandı:", rowData.foto);
          setSelectedImage(rowData.foto);
          setShowImageDialog(true);
        }}
      />
    );
  };
  
  const dateBodyTemplate = (rowData) => {
    return formatDate(rowData.tarih);
  };
  const gunFilterTemplate = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={days.map(day => ({ label: day, value: day }))}
        onChange={(e) => options.filterApplyCallback(e.value)} // ✅ burada düzeltildi
        placeholder="Durum Seçiniz"
        className="p-column-filter"
      />
    );
  };
  
  const days = [
    "Silindi",
    "Tamamlandı",
    "Bildirildi",
    "İşlemde",
  ];
  return (
    <div className="people-container neighborhood-container">
      <Toast ref={toast} />
    
      <div  className="border-area hidden">
        <div className="filter-area">
          <h1 className="page-title">Filtrele</h1>
          <div
            className="filter-form"
            style={{ display: "flex", padding: "0" }}
          >
            <input
              type="date"
              className="filter-input"
              value={dateRange.basla}
              onChange={(e) =>
                setDateRange((prev) => ({ ...prev, basla: e.target.value }))
              }
            />

            
            <button
              type="button"
              className="filter-button"
              onClick={() => fetchTaskLists(dateRange)}
            >
              Filtrele
            </button>
          </div>
        </div>
      </div>
      <h2 style={{marginTop: '20px'}}>Atık havuzu listesi</h2>
      {tableData.length > 0 && (     <>

        <DataTable 
          value={tableData} 
          className="apartments-table route-plans-table"
          sortMode="multiple"      
          paginator 
          rows={30} 
          stripedRows 
          responsiveLayout="scroll" filterDisplay="row" 
          showGridlines
     
          rowsPerPageOptions={[15, 30, 50]}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Toplam {totalRecords} kayıttan {first} - {last} arası gösteriliyor"
        >
        <Column
          field="adres"
          header="Adres"
          sortable
          body={(rowData) => (
            <span title={rowData.gonderenId}>{rowData.adres}</span>
          )}
        ></Column>
          <Column field="detay" header="Detay"  ></Column>
          <Column 
                    field="durum" 
                    header="Durum" 
                    filter   showFilterMatchModes={false}
                    filterMatchMode="equals"   // ✅ Tam eşleşme
                    filterElement={gunFilterTemplate}
                    />
              
     
          <Column
          field="tarih"
          header="Tarih"
          sortable
          body={dateBodyTemplate}
        />
        <Column field="alanKisi" header="Şoför" sortable />
        <Column
  header="Konum"
  body={(rowData) => {
    if (!rowData.konum) return null;

    // konum formatı: "lat,lng" örn: "38.4177453,27.1570814"
    const [lat, lng] = rowData.konum.split(",");

    const mapsUrl = `https://www.google.com/maps?q=${lat},${lng}`;

    return (
      <a
        href={mapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#18964e", cursor: "pointer", textDecoration: "underline" }}
        title="Google Maps'te aç"
      >
        Haritada Gör
      </a>
    );
  }}
/>
        <Column header="Fotoğraf" body={imageBodyTemplate} />
         
        </DataTable>
          <Dialog
          visible={showImageDialog}
          onHide={() => setShowImageDialog(false)}
          header="Fotoğraf Önizleme"
          style={{ width: "60vw" }}
        >
          {selectedImage && (
            <img
              src={selectedImage}
              alt="Büyük Fotoğraf"
              style={{ width: "100%", height: "auto" }}
            />
          )}
        </Dialog>    </>

      )}

      {tableData.length === 0 && (
        <p style={{ marginTop: "20px", fontStyle: "italic", color: "#666" }}>
          Henüz eklenmiş kayıt yok.
        </p>
      )}

      <style jsx>{`
        .form-row {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
        }

        .form-group {
          flex: 1;
          min-width: 150px;
        }

        label {
          display: block;
          margin-bottom: 5px;
          font-weight: bold;
        }
   .p-column-filter button {
                        color: #000; display:none;
                    }
        .filter-input {
          width: 100%;
          padding: 8px;
          border: 1px solid #ddd;
          border-radius: 4px;
          height: 45px;
        }

        .filter-input.active {
          background-color: #007acc;
          color: white;
        }

        .apartments-table {
          margin-top: 20px;
        }

        .apartments-table .p-datatable-thead > tr > th {
          background-color: #18964e !important;
          color: white !important;
          font-weight: 600 !important;
          height: 60px !important;
          border: 1px solid #ccc !important;
          text-align: center !important;
        }

        .apartments-table .p-datatable-thead > tr > th .p-column-header-content {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          height: 100% !important;
        }

        .apartments-table .p-datatable-thead > tr > th .p-column-title {
          color: white !important;
          font-weight: 600 !important;
        }

        .apartments-table .p-datatable-tbody > tr > td {
          border: 1px solid #ccc !important;
          padding: 8px !important;
          text-align: center !important;
        }

        .apartments-table .p-datatable-tbody > tr:nth-child(even) {
          background-color: #f9f9f9 !important;
        }

        .apartments-table .p-datatable-tbody > tr:hover {
          background-color: #f0f0f0 !important;
        }

        .apartments-table .p-sortable-column-icon {
          color: white !important;
        }

        .apartments-table .p-sortable-column:hover {
          background-color: #147a3d !important;
        }

        .apartments-table .p-paginator {
          background-color: #f8f9fa !important;
          border: 1px solid #dee2e6 !important;
          border-top: none !important;
        }

        .apartments-table .p-paginator .p-paginator-pages .p-paginator-page {
          border: 1px solid #dee2e6 !important;
          background-color: white !important;
          color: #495057 !important;
        }

        .apartments-table .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
          background-color: #18964e !important;
          border-color: #18964e !important;
          color: white !important;
        }

        .apartments-table .p-paginator .p-paginator-pages .p-paginator-page:hover {
          background-color: #147a3d !important;
          border-color: #147a3d !important;
          color: white !important;
        }

        .apartments-table .p-paginator .p-paginator-first,
        .apartments-table .p-paginator .p-paginator-prev,
        .apartments-table .p-paginator .p-paginator-next,
        .apartments-table .p-paginator .p-paginator-last {
          border: 1px solid #dee2e6 !important;
          background-color: white !important;
          color: #495057 !important;
        }

        .apartments-table .p-paginator .p-paginator-first:hover,
        .apartments-table .p-paginator .p-paginator-prev:hover,
        .apartments-table .p-paginator .p-paginator-next:hover,
        .apartments-table .p-paginator .p-paginator-last:hover {
          background-color: #18964e !important;
          border-color: #18964e !important;
          color: white !important;
        }

        .apartments-table .p-paginator .p-paginator-first.p-disabled,
        .apartments-table .p-paginator .p-paginator-prev.p-disabled,
        .apartments-table .p-paginator .p-paginator-next.p-disabled,
        .apartments-table .p-paginator .p-paginator-last.p-disabled {
          background-color: #e9ecef !important;
          border-color: #dee2e6 !important;
          color: #6c757d !important;
        }

        .apartments-table .p-paginator .p-dropdown {
          border: 1px solid #dee2e6 !important;
        }

        .apartments-table .p-paginator .p-dropdown:hover {
          border-color: #18964e !important;
        }

        .p-dropdown-label.p-inputtext {
          line-height: 43px !important;
          padding-left: 10px !important;
        }

        .neighborhood-filter-submit-button {
          background-color: #18964e;
          color: white;
          border: none;
          padding: 10px;
          border-radius: 5px;
          cursor: pointer;
          font-weight: 600;
          height: 45px;
        }

        .neighborhood-filter-submit-button:disabled {
          background-color: #a0a0a0;
          cursor: not-allowed;
        }

        .filter-form input {
          width: 200px;
          height: 45px;
          border: 1px solid #ddd;
          border-radius: 4px;
          margin-right: 10px;
        }

        .filter-form button {
          background-color: #18964e;
          color: white;
          border: none;
          padding: 10px;
          border-radius: 5px;
          cursor: pointer;
        }
      `}</style>
    </div>
  );
};

export default WastePool;
